module.exports = __webpack_public_path__ + "img/27.3b6b0028.png";